import { render } from "./MyOrderSingle.vue?vue&type=template&id=42849b10&scoped=true"
import script from "./MyOrderSingle.vue?vue&type=script&lang=js"
export * from "./MyOrderSingle.vue?vue&type=script&lang=js"

import "./MyOrderSingle.vue?vue&type=style&index=0&id=42849b10&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42849b10"]])

export default __exports__